import i18n from 'i18next';

export const REALTIME_POTENTIAL_ATTRIBUTE_KEYS = [
  'Length',
  'Width',
  'Distance',
  'Chord',
  'Chord Points',
  'Distance from Nacelle',
  'Tower Side',
  'Nacelle Side',
  'Transition Piece Side',
];

export const OVERRIDABLE_COMPUTED_METRIC_ATTRIBUTE_KEYS = [
  'Length',
  'Width',
  'Distance',
  'Distance from Nacelle',
];

export const CONFIRM_PRIMARY_COPY = i18n.t(
  'damages.confirmPrimaryObservationCopy',
  'Mark this as the Primary Observation. All linked Observations from this Inspection will be shown on the Damages table.'
);
